module.exports = __webpack_public_path__ + "assets/img/b78098682a54fa9483744e77daaa93ce.svg";